import React from 'react';

interface CapsuleIconProps {
  className?: string;
}

const CapsuleIcon: React.FC<CapsuleIconProps> = ({ className = "h-8 w-8" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <radialGradient id="nucleusGlow" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="currentColor" stopOpacity="0.4" />
        <stop offset="70%" stopColor="currentColor" stopOpacity="0.1" />
        <stop offset="100%" stopColor="currentColor" stopOpacity="0" />
      </radialGradient>
    </defs>

    {/* Nucleus glow */}
    <circle cx="12" cy="12" r="8" fill="url(#nucleusGlow)" />

    {/* First orbital ring - horizontal */}
    <ellipse
      cx="12"
      cy="12"
      rx="10"
      ry="4"
      stroke="currentColor"
      strokeWidth="1.2"
      fill="none"
      opacity="0.75"
    />

    {/* Second orbital ring - diagonal 1 */}
    <ellipse
      cx="12"
      cy="12"
      rx="10"
      ry="4"
      stroke="currentColor"
      strokeWidth="1.2"
      fill="none"
      opacity="0.75"
      transform="rotate(60 12 12)"
    />

    {/* Third orbital ring - diagonal 2 */}
    <ellipse
      cx="12"
      cy="12"
      rx="10"
      ry="4"
      stroke="currentColor"
      strokeWidth="1.2"
      fill="none"
      opacity="0.75"
      transform="rotate(-60 12 12)"
    />

    {/* Nucleus - central sphere */}
    <circle
      cx="12"
      cy="12"
      r="2.5"
      fill="currentColor"
      opacity="0.9"
    />
    <circle
      cx="12"
      cy="12"
      r="1.5"
      fill="currentColor"
      opacity="0.5"
    />

    {/* Electrons on first orbit */}
    <circle cx="22" cy="12" r="1.2" fill="currentColor" opacity="0.85">
      <animateTransform
        attributeName="transform"
        type="rotate"
        from="0 12 12"
        to="360 12 12"
        dur="8s"
        repeatCount="indefinite"
      />
    </circle>
    <circle cx="2" cy="12" r="1.2" fill="currentColor" opacity="0.85">
      <animateTransform
        attributeName="transform"
        type="rotate"
        from="180 12 12"
        to="540 12 12"
        dur="8s"
        repeatCount="indefinite"
      />
    </circle>

    {/* Electrons on second orbit */}
    <circle cx="17" cy="4.3" r="1" fill="currentColor" opacity="0.8">
      <animateTransform
        attributeName="transform"
        type="rotate"
        from="60 12 12"
        to="420 12 12"
        dur="6s"
        repeatCount="indefinite"
      />
    </circle>
    <circle cx="7" cy="19.7" r="1" fill="currentColor" opacity="0.8">
      <animateTransform
        attributeName="transform"
        type="rotate"
        from="240 12 12"
        to="600 12 12"
        dur="6s"
        repeatCount="indefinite"
      />
    </circle>

    {/* Electrons on third orbit */}
    <circle cx="17" cy="19.7" r="1" fill="currentColor" opacity="0.8">
      <animateTransform
        attributeName="transform"
        type="rotate"
        from="-60 12 12"
        to="300 12 12"
        dur="7s"
        repeatCount="indefinite"
      />
    </circle>
    <circle cx="7" cy="4.3" r="1" fill="currentColor" opacity="0.8">
      <animateTransform
        attributeName="transform"
        type="rotate"
        from="120 12 12"
        to="480 12 12"
        dur="7s"
        repeatCount="indefinite"
      />
    </circle>
  </svg>
);

export default CapsuleIcon;
